














































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { setLocalStorage, getSessionStorage } from '@/store/src/utils'
import pageIndexData from '@/config/page_index_config'
const loginerModule = namespace('loginer')
const pageIndex = namespace('pageIndex')
@Component
export default class AppHeader extends Vue {
	@loginerModule.State('loginerName') private loginerName?: string
	@loginerModule.State('loginerNotifyNumber') private loginerNotifyNumber?: number
	@pageIndex.State('pageIndex') private pageIndex?: string

	private pageIndexObj (pageId: string) {
		let currentPageObj: any = {}
		const findPage = (pageObj: any, findPageId: string) => {
			for (const key of Object.keys(pageObj)) {
				if (pageObj[key].id === findPageId) {
					currentPageObj = pageObj[key]
					break
				} else if (pageObj[key].children) {
					findPage(pageObj[key].children, findPageId)
				}
			}
		}
		findPage(pageIndexData, pageId)
		return currentPageObj
	}
	private get pageIndexArr () {
		const pageIndexArr: any = []
		const findPageObj = (currentPageId: string = '') => {
			const pageObj = this.pageIndexObj(currentPageId)
			pageIndexArr.push(pageObj)
			if (pageObj.parentId) {
				findPageObj(pageObj.parentId)
			}
		}
		findPageObj(this.pageIndex)
		pageIndexArr.reverse()
		return pageIndexArr
	}
	private onOutSysConfirm () {
		(this as any).$fxConfirm('确定要退出吗？').then(() => {
			this.onOutSysClick()
		})
	}
	private onOutSysClick () {
		(this as any).$fxMessage.success('退出成功')
		this.$router.push(getSessionStorage('loginUrl'))
	}
	private onNotifyClick () {
		this.$router.push('notify')
	}
}

